import client from '@/services/client'
import type {
  ICreateRole,
  IRole,
  IRoleAll,
  IRolePermission,
} from '@/types/RoleTypes'

import type { AxiosResponse } from 'axios'

const getRoles = async (): Promise<AxiosResponse<IRoleAll[]>> => {
  return await client.get<IRoleAll[]>(`roles`)
}

const getRoleById = async (id: string): Promise<AxiosResponse<IRole>> => {
  return await client.get<IRole>(`roles/${id}`)
}

const getPermissionsByRoleId = async (
  roleId: string
): Promise<AxiosResponse<IRolePermission[]>> => {
  return await client.get<IRolePermission[]>(`/roles/${roleId}/permissions`)
}

const getPermissions = async (): Promise<AxiosResponse<IRolePermission[]>> => {
  return await client.get<IRolePermission[]>(`/permissions`)
}

const updateRole = async (
  id: string,
  payload: ICreateRole
): Promise<AxiosResponse<IRole>> => {
  return await client.patch<IRole>(`roles/${id}`, payload)
}

const createRole = async (
  payload: ICreateRole
): Promise<AxiosResponse<IRole>> => {
  return await client.post<IRole>(`roles`, payload)
}

const deleteRole = async (id: string): Promise<AxiosResponse<void>> => {
  return await client.delete<void>(`roles/${id}`)
}

const updateRolePermissions = async (
  roleId: string,
  permissions: IRolePermission[]
): Promise<AxiosResponse<void>> => {
  return await client.put<void>(`roles/${roleId}/permissions`, {
    permissions: permissions.map(p => p.name),
  })
}

const getUserPermissions = async (userUUID: string): Promise<string[]> => {
  return client.get(`users/${userUUID}/roles`)
}

export const RoleRepository = {
  getRoles,
  getRoleById,
  getPermissionsByRoleId,
  getPermissions,
  updateRole,
  createRole,
  deleteRole,
  updateRolePermissions,
  getUserPermissions,
}
